import {AfterViewInit, Component, inject, QueryList, ViewChildren} from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { CustomTitle } from 'lib-base';
import { TabViewModule } from 'primeng/tabview';
import { SolicitudesHistorialComponent } from './solicitudes-historial/solicitudes-historial.component';
import {CustomTitleDirective} from "../../../shared/clases/custom-title.directive";

@Component({
  selector: 'app-mis-pqrsd',
  standalone: true,
  imports: [TabViewModule, TranslateModule, CustomTitle,
    SolicitudesHistorialComponent
  ],
  templateUrl: './mis-pqrsd.component.html',
  styleUrl: './mis-pqrsd.component.scss'
})
export class MisPQRSDComponent implements AfterViewInit {

  private titleService:CustomTitleDirective = inject(CustomTitleDirective);

  activeTabIndex: number = 0;

  @ViewChildren(SolicitudesHistorialComponent) solicitudesHistorialComponents !: QueryList<SolicitudesHistorialComponent>;

  ngAfterViewInit(): void {
    this.titleService.changeTitle('msg.misPQRSD');
    this.solicitudesHistorialComponents.get(0)?.getMisPqrsd();
  }

  activeIndexChange(index: number) {
    this.activeTabIndex = index;
    if (this.solicitudesHistorialComponents && this.solicitudesHistorialComponents.length > index) {
      this.solicitudesHistorialComponents.get(index)?.getMisPqrsd();
    }
  }
}
